export default __webpack_public_path__ + "static/media/heart.59848f48.png";